module.exports = __webpack_public_path__ + "img/30@3x.781ae780.png";